import { Component, Input, OnInit } from '@angular/core';
import { BorrowerValue } from 'app/models/dto/borrower-value.model';

@Component({
  selector: 'app-borrower-doing-business-as-name',
  templateUrl: './borrower-doing-business-as-name.component.html',
  styleUrls: ['./borrower-doing-business-as-name.component.scss'],
  standalone: false
})
export class BorrowerDoingBusinessAsNameComponent implements OnInit {
  @Input() borrowerValues: BorrowerValue[];

  doingBusinessAsName: string | null | undefined;

  constructor() { }

  ngOnInit(): void {
    this.doingBusinessAsName = this.borrowerValues?.find(value => value?.alias === 'doingBusinessAsName')?.value;
  }
}
